import { baseApi } from './base.api';
import { API_VERSION, PATH_PLAYGROUND_API } from '../constants/api-routes';

export const playgroundService = baseApi.injectEndpoints({
  endpoints: (build): any => {
    return {
      getPlaygroundChat: build.query({
        query: ({ projectId, chatId }) => {
          const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;

          return {
            url: `${version}/${PATH_PLAYGROUND_API.ROOT}/${projectId}${PATH_PLAYGROUND_API.CHAT}/${chatId}`,
          };
        },
        providesTags: ['PlaygroundChat'],
      }),
      createPlaygroundChat: build.mutation({
        query: ({ projectId }) => {
          const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;

          return {
            url: `${version}/${PATH_PLAYGROUND_API.ROOT}/${projectId}${PATH_PLAYGROUND_API.CHAT}`,
            method: 'POST',
          };
        },
      }),
    };
  },
});

export const { useLazyGetPlaygroundChatQuery, useCreatePlaygroundChatMutation } = playgroundService;
